var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCaretDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1799_10433",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 10,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.44935 1.19497L12.3148 5.06078C12.7289 5.47484 12.4359 6.18259 11.8509 6.18259H4.11808C3.53309 6.18259 3.24011 5.47484 3.65322 5.06078L7.51962 1.19497C7.77647 0.938264 8.19251 0.938264 8.44935 1.19497ZM7.54892 14.8051L3.68252 10.9391C3.26941 10.5252 3.56239 9.81744 4.14738 9.81744H11.8802C12.4652 9.81744 12.7582 10.5252 12.3441 10.9391L8.47865 14.8051C8.2218 15.0617 7.80577 15.0617 7.54892 14.8051Z",
    fill: "#6B6C7E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1799_10433)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.0008,
    height: 15.9998,
    fill: "#004DF0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCaretDouble);
export default __webpack_public_path__ + "static/media/Icon-caret-double.976b2a286186d5be35d04e7d63cd451a.svg";
export { ForwardRef as ReactComponent };